import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import AppLogo from '@/components/welcome/AppLogo';
import WelcomeButtons from '@/components/welcome/WelcomeButtons';
import { useIsMobile } from '@/hooks/use-mobile';
import { usePermissions } from '@/contexts/unified-permissions';

const Welcome = () => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const { isAuthenticated, authReady } = usePermissions();

  useEffect(() => {
    if (authReady && isAuthenticated) {
      navigate('/journal', { replace: true });
    }
  }, [authReady, isAuthenticated, navigate]);
  
  const handleGetStarted = () => {
    navigate('/auth/signup');
  };
  
  const handleLogin = () => {
    navigate('/auth/login');
  };
  
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 'env(safe-area-inset-top)',
        paddingBottom: 'env(safe-area-inset-bottom)',
        paddingLeft: 'env(safe-area-inset-left)',
        paddingRight: 'env(safe-area-inset-right)',
        background: 'linear-gradient(to bottom, #7c3aed, #1e3a8a)' // purple-600 to indigo-800
      }}
    >
      <motion.div
        className="w-full max-w-md flex flex-col items-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.7 }}
      >
        {/* Logo */}
        <AppLogo />
        
        {/* Content */}
        <div className="mt-10 mb-12 text-center">
          <motion.h1
            className="text-4xl font-bold text-white mb-4"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.5 }}
          >
            {isMobile ? (
              <>
                Your Journey.<br />
                All Of It.
              </>
            ) : (
              "Your Journey. All Of It."
            )}
          </motion.h1>
          
          <motion.p
            className="text-xl text-white/90 max-w-md"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.5 }}
          >
            Track your progress, master techniques, and elevate your Jiu Jitsu game with The Mat Monster.
          </motion.p>
        </div>
        
        {/* Buttons */}
        <WelcomeButtons onGetStarted={handleGetStarted} onLogin={handleLogin} />
      </motion.div>
      
      {/* Version */}
      <motion.div
        className="absolute bottom-6 text-white/60 text-sm"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.5 }}
        style={{
          left: '50%',
          transform: 'translateX(-50%)'
        }}
      >
        Version 1.0.2
      </motion.div>
    </div>
  );
};

export default Welcome;
